import React, { useEffect, useState } from "react";
import { DataGrid, GridToolbarQuickFilter } from "@mui/x-data-grid";
import axios from "axios";
import {
  Box,
  Typography,
  Button,
  TextField,
  Modal,
  MenuItem,
  FormControl,
  InputLabel,
  Select,
  Chip,
  Paper,
  IconButton,
  Tooltip,
  Card,
  CardContent,
  Grid,
  Avatar,
  Fade,
  Backdrop,
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
  Divider,
  Alert,
  Autocomplete,
} from "@mui/material";
import CloseIcon from "@mui/icons-material/Close";
import EditIcon from "@mui/icons-material/Edit";
import SearchIcon from "@mui/icons-material/Search";
import PersonIcon from "@mui/icons-material/Person";
import BusinessIcon from "@mui/icons-material/Business";
import BadgeIcon from "@mui/icons-material/Badge";
import PeopleAltIcon from "@mui/icons-material/PeopleAlt";
import WarningAmberIcon from "@mui/icons-material/WarningAmber";
import CheckCircleOutlineIcon from "@mui/icons-material/CheckCircleOutline";
import EventIcon from "@mui/icons-material/Event";
import LocationOnIcon from "@mui/icons-material/LocationOn";
import FilterListIcon from "@mui/icons-material/FilterList";
import TwoWheelerIcon from "@mui/icons-material/TwoWheeler";
import SaveIcon from "@mui/icons-material/Save";
import FileDownloadIcon from "@mui/icons-material/FileDownload";
import CancelIcon from "@mui/icons-material/Cancel";
import AddIcon from "@mui/icons-material/Add";
import RemoveCircleOutlineIcon from "@mui/icons-material/RemoveCircleOutline";

import Topbar from "../../topbar/Topbar";
import Sidebar from "../../sidebar/Sidebar";
import SPXlogo from "../../Images/Bmpower_Logo/BMP - SPX.jpg";

// ── Hubs by Region ────────────────────────────────────────────────────────────
export const HUBS_BY_REGION = {
  "NCR 1 South": [
    "Apelo Hub",
    "Arnaiz Hub",
    "Bagumbayan Hub",
    "CAA Hub",
    "Cupang Hub",
    "Dasa Hub",
    "FTI Hub",
    "Las Pinas Hub",
    "Makati Hub",
    "Makati-Magallanes Hub",
    "Manuyo Uno Hub",
    "Marcelo Green Hub",
    "Pasay Hub",
    "Tambo Hub",
    "Tunasan Hub",
  ].sort((a, b) => a.localeCompare(b)),
  "NCR 2 East": [
    "Angono Hub",
    "Antipolo Hub",
    "Baltao Hub",
    "Baras Hub",
    "Binangonan Hub",
    "Cainta Hub",
    "Mambugan Hub",
    "Morong Rizal Hub",
    "Q Plaza Hub",
    "Redgold Hub",
    "Rodriguez Hub",
    "San Isidro Rodriguez Hub",
    "San Mateo Hub",
    "Tanay Hub",
    "Taytay Hub",
    "Teresa Rizal Hub",
    "Upper Antipolo Hub",
    "Payatas Hub",
    "Cubao Hub",
    "Lower QC Hub",
    "Tandang Sora Hub",
    "West QC Hub",
    "Batasan Hub",
    "Culiat Hub",
    "East QC Hub",
    "Holy Spirit Hub",
    "M.Balara Hub",
    "Wack Wack Hub",
    "San Juan Hub",
    "MLQ Hub",
  ].sort((a, b) => a.localeCompare(b)),
  "NCR 3 Central": [
    "Escoda Hub",
    "Jaboneros Hub",
    "Paco Hub",
    "Palanca Hub",
    "Pandacan Hub",
    "Tondo Hub",
    "Vitas Tondo Hub",
    "Mandaluyong Hub",
    "Malaya Ibaba Hub",
    "Daanghari Navotas Hub",
    "MINI Hub Lavezares",
    "Navotas Hub",
    "Second Avenue Hub",
    "Marikina Hub",
    "Upper Marikina Hub",
    "Pasig Hub",
    "Pasig-Rosario Hub",
    "Maybunga Hub",
    "Amang Rodriguez Hub",
    "Bambang Pasig Hub",
    "Congressional Hub",
    "Del Monte Ave Hub",
    "Reliance Hub",
    "MFM Pasig Hub",
    "Mercedes Hub",
    "Ugong Hub",
  ].sort((a, b) => a.localeCompare(b)),
  "NCR 4 North": [
    "North East Caloocan Hub",
    "Upper QC Hub",
    "West Grace Park Hub",
    "M Lozada",
    "Pateros Hub",
    "Ruhale Hub",
    "Camanava Hub",
    "Canumay East Hub",
    "Caybiga Hub",
    "Coloong Hub",
    "Malabon Hub",
    "South Caloocan Hub",
    "Tinajeros Hub",
    "Valenzuela Hub",
    "Viente Reales Hub",
    "Balingasa Hub",
    "Amparo Hub",
    "Bagumbong Hub",
    "Caloocan Hub",
    "Northwest Caloocan Hub",
    "Tala Hub",
  ].sort((a, b) => a.localeCompare(b)),
  "MIN 2 Caraga": [
    "Surigao Downtown Hub",
    "Surigao Del Norte Hub",
    "Mainit Hub",
    "Cantilan Hub",
    "Butuan Hub",
    "Ampayon Hub",
    "Ambago Hub",
    "Buenavista Hub",
    "Cabadbaran Hub",
    "Bayugan Hub",
    "San Francisco Hub",
    "Taganaan Mobile Hub",
    "Placer Mobile Hub",
    "Malimono Mobile Hub",
    "Hinatuan Mobile Hub",
    "Lingig Mobile Hub",
    "MB Crossing Hub",
    "RC Hub",
  ].sort((a, b) => a.localeCompare(b)),
  "MIN 3 Davao": [
    "Bangkal hub",
    "Boulevard Hub",
    "Davao Buhangin Hub",
    "Davao Calinan Hub",
    "Davao Carmen Hub",
    "Davao Hub",
    "Davao Ma-a Hub",
    "Davao Marfori Hub",
    "Davao Matina Aplaya Hub",
    "Davao Obrero Hub",
    "Davao RC/DC",
    "Davao RC/DC - MIDMILE",
    "Davao Tibungco Hub",
    "Davao Toril Hub",
    "Davao Tugbok Hub",
    "Digos Hub",
    "Digos Aurora Hub",
    "Gov. Gen Hub",
    "Laak Hub",
    "Lupon Hub",
    "Maragusan Hub",
    "Mati Hub",
    "MB Bansalan Hub",
    "MB Digos Hub",
    "MB Malabog",
    "MB Malalag Hub",
    "MB Mandug Hub",
    "MB Mawab Hub",
    "MB Padada Hub",
    "MB Sta. Maria Hub",
    "MB Tibungol Hub",
    "MB Mabunao Hub",
    "Montevista Hub",
    "New Corella Hub",
    "Panabo Hub",
    "Pantukan Hub",
    "Santo Tomas Davao Hub",
    "Tagum Hub",
    "Tagum Magugpo East Hub",
    "PHM_SDD",
    "Davao Dumoy Hub",
  ].sort((a, b) => a.localeCompare(b)),
  "MIN 5 ZamPen/MisOcc": ["Pagadian Hub"].sort((a, b) => a.localeCompare(b)),
};

export const HUB_COORDINATORS = {
  "Apelo Hub": "Arnel Curiba",
  "Arnaiz Hub": "Arnel Curiba",
  "Bagumbayan Hub": "Arnel Curiba",
  "CAA Hub": "Arnel Curiba",
  "Cupang Hub": "Arnel Curiba",
  "Dasa Hub": "Arnel Curiba",
  "FTI Hub": "Arnel Curiba",
  "Las Pinas Hub": "Arnel Curiba",
  "Makati Hub": "Arnel Curiba",
  "Makati-Magallanes Hub": "Arnel Curiba",
  "Manuyo Uno Hub": "Arnel Curiba",
  "Marcelo Green Hub": "Arnel Curiba",
  "Pasay Hub": "Arnel Curiba",
  "Tambo Hub": "Arnel Curiba",
  "Tunasan Hub": "Arnel Curiba",
  "Angono Hub": "Jerome Demayo",
  "Antipolo Hub": "Jerome Demayo",
  "Baltao Hub": "Jerome Demayo",
  "Baras Hub": "Jerome Demayo",
  "Binangonan Hub": "Jerome Demayo",
  "Cainta Hub": "Jerome Demayo",
  "Mambugan Hub": "Jerome Demayo",
  "Morong Rizal Hub": "Jerome Demayo",
  "Q Plaza Hub": "Jerome Demayo",
  "Redgold Hub": "Jerome Demayo",
  "Rodriguez Hub": "Jerome Demayo",
  "San Isidro Rodriguez Hub": "Jerome Demayo",
  "San Mateo Hub": "Jerome Demayo",
  "Tanay Hub": "Jerome Demayo",
  "Taytay Hub": "Jerome Demayo",
  "Teresa Rizal Hub": "Jerome Demayo",
  "Upper Antipolo Hub": "Jerome Demayo",
  "Payatas Hub": "Jerome Demayo",
  "Cubao Hub": "Jerome Demayo",
  "Lower QC Hub": "Jerome Demayo",
  "Tandang Sora Hub": "Jerome Demayo",
  "West QC Hub": "Jerome Demayo",
  "Batasan Hub": "Jerome Demayo",
  "Culiat Hub": "Jerome Demayo",
  "East QC Hub": "Jerome Demayo",
  "Holy Spirit Hub": "Jerome Demayo",
  "M.Balara Hub": "Jerome Demayo",
  "Wack Wack Hub": "Arnel Curiba",
  "San Juan Hub": "Arnel Curiba",
  "Escoda Hub": "Arnel Curiba",
  "Jaboneros Hub": "Arnel Curiba",
  "Paco Hub": "Arnel Curiba",
  "Palanca Hub": "Arnel Curiba",
  "Pandacan Hub": "Arnel Curiba",
  "Tondo Hub": "Arnel Curiba",
  "Vitas Tondo Hub": "Arnel Curiba",
  "Mandaluyong Hub": "Arnel Curiba",
  "Malaya Ibaba Hub": "Arnel Curiba",
  "Daanghari Navotas Hub": "Arnel Curiba",
  "MINI Hub Lavezares": "Arnel Curiba",
  "Navotas Hub": "Arnel Curiba",
  "Second Avenue Hub": "Arnel Curiba",
  "Marikina Hub": "Jerome Demayo",
  "Upper Marikina Hub": "Jerome Demayo",
  "Pasig Hub": "Jerome Demayo",
  "Pasig-Rosario Hub": "Jerome Demayo",
  "Maybunga Hub": "Jerome Demayo",
  "Amang Rodriguez Hub": "Jerome Demayo",
  "Bambang Pasig Hub": "Jerome Demayo",
  "Congressional Hub": "Jerome Demayo",
  "Del Monte Ave Hub": "Jerome Demayo",
  "Reliance Hub": "Jerome Demayo",
  "MFM Pasig Hub": "Jerome Demayo",
  "Mercedes Hub": "Jerome Demayo",
  "Ugong Hub": "Jerome Demayo",
  "North East Caloocan Hub": "Jerome Demayo",
  "Upper QC Hub": "Jerome Demayo",
  "West Grace Park Hub": "Arnel Curiba",
  "M Lozada": "Arnel Curiba",
  "Pateros Hub": "Arnel Curiba",
  "Ruhale Hub": "Arnel Curiba",
  "Camanava Hub": "Arnel Curiba",
  "Canumay East Hub": "Arnel Curiba",
  "Caybiga Hub": "Arnel Curiba",
  "Coloong Hub": "Arnel Curiba",
  "Malabon Hub": "Arnel Curiba",
  "South Caloocan Hub": "Arnel Curiba",
  "Tinajeros Hub": "Arnel Curiba",
  "Valenzuela Hub": "Arnel Curiba",
  "Viente Reales Hub": "Arnel Curiba",
  "Balingasa Hub": "Jerome Demayo",
  "Amparo Hub": "Jerome Demayo",
  "Bagumbong Hub": "Jerome Demayo",
  "Caloocan Hub": "Jerome Demayo",
  "MLQ Hub": "Jerome Demayo",
  "Northwest Caloocan Hub": "Jerome Demayo",
  "Tala Hub": "Jerome Demayo",
  "Surigao Downtown Hub": "Jay Boticario",
  "Surigao Del Norte Hub": "Jay Boticario",
  "Mainit Hub": "Jay Boticario",
  "Cantilan Hub": "Jay Boticario",
  "Butuan Hub": "Erll Dave Jose",
  "Ampayon Hub": "Erll Dave Jose",
  "Ambago Hub": "Erll Dave Jose",
  "Buenavista Hub": "Jay Boticario",
  "Cabadbaran Hub": "Erll Dave Jose",
  "Bayugan Hub": "Erll Dave Jose",
  "San Francisco Hub": "Erll Dave Jose",
  "Taganaan Mobile Hub": "Jay Boticario",
  "Placer Mobile Hub": "Jay Boticario",
  "Malimono Mobile Hub": "Jay Boticario",
  "Hinatuan Mobile Hub": "Jay Boticario",
  "Lingig Mobile Hub": "Jay Boticario",
  "MB Crossing Hub": "Erll Dave Jose",
  "RC Hub": "Jay Boticario",
  "Bangkal hub": "Jonalyn Señoron",
  "Boulevard Hub": "Jonalyn Señoron",
  "Davao Buhangin Hub": "Jonalyn Señoron",
  "Davao Calinan Hub": "Jonalyn Señoron",
  "Davao Carmen Hub": "Jonalyn Señoron",
  "Davao Hub": "Jonalyn Señoron",
  "Davao Ma-a Hub": "Jonalyn Señoron",
  "Davao Marfori Hub": "Jonalyn Señoron",
  "Davao Matina Aplaya Hub": "Jonalyn Señoron",
  "Davao Obrero Hub": "Jonalyn Señoron",
  "Davao RC/DC": "Jonalyn Señoron",
  "Davao RC/DC - MIDMILE": "Jonalyn Señoron",
  "Davao Tibungco Hub": "Jonalyn Señoron",
  "Davao Toril Hub": "Jonalyn Señoron",
  "Davao Tugbok Hub": "Jonalyn Señoron",
  "Digos Hub": "Jonalyn Señoron",
  "Digos Aurora Hub": "Jonalyn Señoron",
  "Gov. Gen Hub": "Jonalyn Señoron",
  "Laak Hub": "Jonalyn Señoron",
  "Lupon Hub": "Jonalyn Señoron",
  "Maragusan Hub": "Jonalyn Señoron",
  "Mati Hub": "Jonalyn Señoron",
  "MB Bansalan Hub": "Jonalyn Señoron",
  "MB Digos Hub": "Jonalyn Señoron",
  "MB Malabog": "Jonalyn Señoron",
  "MB Malalag Hub": "Jonalyn Señoron",
  "MB Mandug Hub": "Jonalyn Señoron",
  "MB Mawab Hub": "Jonalyn Señoron",
  "MB Padada Hub": "Jonalyn Señoron",
  "MB Sta. Maria Hub": "Jonalyn Señoron",
  "MB Tibungol Hub": "Jonalyn Señoron",
  "MB Mabunao Hub": "Jonalyn Señoron",
  "Montevista Hub": "Jonalyn Señoron",
  "New Corella Hub": "Jonalyn Señoron",
  "Panabo Hub": "Jonalyn Señoron",
  "Pantukan Hub": "Jonalyn Señoron",
  "Santo Tomas Davao Hub": "Jonalyn Señoron",
  "Tagum Hub": "Jonalyn Señoron",
  "Tagum Magugpo East Hub": "Jonalyn Señoron",
  "Davao Dumoy Hub": "Jonalyn Señoron",
  "Pagadian Hub": "Vhenz Morata",
};

// ── Flat OUTLET_DATA ──────────────────────────────────────────────────────────
let _idCounter = 1;
export const OUTLET_DATA = Object.entries(HUBS_BY_REGION).flatMap(
  ([region, hubs]) =>
    hubs.map((hub) => ({
      id: _idCounter++,
      account: "SPX EXPRESS",
      region,
      outlet: hub,
      coordinator: HUB_COORDINATORS[hub] || "",
    })),
);

// ── Constants ─────────────────────────────────────────────────────────────────
const REGION_COLORS = {
  "NCR 1 South": { bg: "#fff3e0", color: "#e65100" },
  "NCR 2 East": { bg: "#e3f2fd", color: "#1565c0" },
  "NCR 3 Central": { bg: "#f3e5f5", color: "#6a1b9a" },
  "NCR 4 North": { bg: "#e8f5e9", color: "#2e7d32" },
  "MIN 2 Caraga": { bg: "#fce4ec", color: "#880e4f" },
  "MIN 3 Davao": { bg: "#fce4ec", color: "#ff1635" },
  "MIN 5 ZamPen/MisOcc": { bg: "#e4f5fc", color: "#005a70" },
};
const SPX_BLUE = "#2e6385ff";
const SPX_DARK = "#0c2e3fff";

// ── Status category sets ──────────────────────────────────────────────────────
// These drive which date fields are enabled/disabled
const UNDEPLOY_STATUSES = [
  "Inactive",
  "AWOL",
  "Resigned",
  "Terminated",
  "Back Out",
];
const DEPLOY_STATUSES = ["Deployed", "Shadowing training"];

// ── Resolve employee-level fields from deployStatus ───────────────────────────
// status  → "Active" | "Inactive"   (used by Employee Management)
// remarks → human-readable reason   (visible everywhere)
function resolveEmployeeFields(deployStatus) {
  switch (deployStatus) {
    case "Deployed":
    case "Shadowing training":
      return { status: "Active", remarks: "Employed" };
    case "Inactive":
      return { status: "Inactive", remarks: "Inactive" };
    case "AWOL":
      return { status: "Inactive", remarks: "AWOL" };
    case "Resigned":
      return { status: "Inactive", remarks: "Resigned" };
    case "Terminated":
      return { status: "Inactive", remarks: "Terminated" };
    case "Back Out":
      return { status: "Inactive", remarks: "Back Out" };
    default:
      return { status: "Active", remarks: "Employed" };
  }
}

// ── Helpers ───────────────────────────────────────────────────────────────────
function formatDate(dateStr) {
  if (!dateStr) return "—";
  const d = new Date(dateStr);
  if (isNaN(d)) return "—";
  return d.toLocaleDateString("en-PH", {
    year: "numeric",
    month: "short",
    day: "numeric",
  });
}
function todayISO() {
  return new Date().toISOString().split("T")[0];
}
function findHub(outletName) {
  return OUTLET_DATA.find(
    (o) => o.outlet.trim().toLowerCase() === outletName?.trim().toLowerCase(),
  );
}

// ── Build assignment maps ─────────────────────────────────────────────────────
function buildAssignmentMaps(allData) {
  const spxAll = allData.filter(
    (e) => e.clientAssigned?.toUpperCase() === "SPX EXPRESS",
  );
  const activeRiders = spxAll.filter(
    (e) => e.status?.toLowerCase() === "active" && e.outlet,
  );
  const coordinators = spxAll.filter(
    (e) =>
      ["Tactical Coordinator", "Account Coordinator"].includes(e.position) &&
      e.status?.toLowerCase() === "active",
  );

  const hubAssignments = {};
  activeRiders.forEach((emp) => {
    const hub = findHub(emp.outlet);
    if (!hub) return;
    if (!hubAssignments[hub.id]) hubAssignments[hub.id] = { riders: [] };
    hubAssignments[hub.id].riders.push({
      employeeId: emp._id,
      employeeName: `${emp.firstName} ${emp.lastName}`,
      position: emp.position,
      deployStatus: emp.deployStatus || "Inactive",
      deployDate: emp.deployDate || null,
      undeployDate: emp.undeployDate || null,
    });
  });

  const coordAssignments = {};
  coordinators.forEach((emp) => {
    const hub = findHub(emp.outlet);
    if (hub) {
      coordAssignments[hub.id] = {
        employeeId: emp._id,
        employeeName: `${emp.firstName} ${emp.lastName}`,
        status: emp.deployStatus === "Deployed" ? "Active" : "Inactive",
      };
    }
  });

  const floatingRiders = spxAll.filter((e) => {
    if (e.status?.toLowerCase() !== "active") return false;
    if (["Tactical Coordinator", "Account Coordinator"].includes(e.position))
      return false;
    if (!e.outlet) return true;
    return !findHub(e.outlet);
  });

  return {
    activeRiders,
    coordinators,
    hubAssignments,
    coordAssignments,
    floatingRiders,
  };
}

function buildHubSummary(hubAssignments) {
  return Object.entries(hubAssignments).map(([hubId, data]) => {
    const hub = OUTLET_DATA.find((o) => o.id === parseInt(hubId));
    return {
      hubId: parseInt(hubId),
      hubName: hub?.outlet || "Unknown",
      region: hub?.region || "",
      riderCount: data.riders.length,
      deployedCount: data.riders.filter((r) => r.deployStatus === "Deployed")
        .length,
    };
  });
}

// ═════════════════════════════════════════════════════════════════════════════
export default function SPXHubs() {
  const [allSpxData, setAllSpxData] = useState([]);
  const [activeRiders, setActiveRiders] = useState([]);
  const [spxCoordinators, setSpxCoordinators] = useState([]);
  const [hubAssignments, setHubAssignments] = useState({});
  const [coordAssignments, setCoordAssignments] = useState({});
  const [floatingRiders, setFloatingRiders] = useState([]);

  const [filteredOutlets, setFilteredOutlets] = useState(OUTLET_DATA);
  const [filterStatus, setFilterStatus] = useState("ALL");
  const [filterRegion, setFilterRegion] = useState("ALL");
  const [filterCoordinator, setFilterCoordinator] = useState("ALL");
  const [searchText, setSearchText] = React.useState("");

  // Hub modal
  const [openHubModal, setOpenHubModal] = useState(false);
  const [selectedHub, setSelectedHub] = useState(null);
  const [hubRiders, setHubRiders] = useState([]);
  const [isEditing, setIsEditing] = useState(false);
  const [assignedCoordId, setAssignedCoordId] = useState("");
  const [coordStatus, setCoordStatus] = useState("Inactive");
  const [addRiderId, setAddRiderId] = useState("");
  const [addDeployDate, setAddDeployDate] = useState(todayISO());
  const [saveError, setSaveError] = useState("");

  const [openSummaryModal, setOpenSummaryModal] = useState(false);
  const [sidebarOpen, setSidebarOpen] = useState(false);

  const role = localStorage.getItem("roleAccount");
  const canEdit = ["SPX COORDINATOR", "MIS", "SPX ACCOUNT SUPERVISOR"].includes(
    role,
  );
  const XLSX = require("sheetjs-style");

  const canAccessEdit =
    canEdit ||
    [
      "HR HEAD",
      "HR OFFICER",
      "SPX HR SPECIALIST",
      "HR COORDINATOR SPECIALIST",
    ].includes(role);

  useEffect(() => {
    const check = () =>
      setSidebarOpen(localStorage.getItem("sidebarOpen") === "true");
    check();
    window.addEventListener("storage", check);
    const iv = setInterval(check, 100);
    return () => {
      window.removeEventListener("storage", check);
      clearInterval(iv);
    };
  }, []);

  const fetchAndApply = async () => {
    try {
      const { data } = await axios.get(
        "https://api-map.bmphrc.com/get-merch-accounts",
      );
      const { activeRiders, hubAssignments, coordAssignments, floatingRiders } =
        buildAssignmentMaps(data);
      setAllSpxData(
        data.filter((e) => e.clientAssigned?.toUpperCase() === "SPX EXPRESS"),
      );
      setActiveRiders(activeRiders);
      setHubAssignments(hubAssignments);
      setCoordAssignments(coordAssignments);
      setFloatingRiders(floatingRiders);
    } catch (e) {
      console.error("Error fetching:", e);
    }
  };

  useEffect(() => {
    const fetchCoordinators = async () => {
      try {
        const res = await axios.post(
          "https://api-map.bmphrc.com/get-coordinators",
        );
        setSpxCoordinators(res.data.data);
      } catch (err) {
        console.error("Failed to fetch coordinators", err);
      }
    };
    fetchCoordinators();
  }, []);

  useEffect(() => {
    fetchAndApply();
  }, []);

  // ── Filters ───────────────────────────────────────────────────────────────
  const applyFilters = (status, region, coordinator = "ALL") => {
    let result = OUTLET_DATA;
    if (region && region !== "ALL")
      result = result.filter((o) => o.region === region);
    if (coordinator && coordinator !== "ALL")
      result = result.filter((o) => (o.coordinator || "") === coordinator);
    if (status === "Has Riders")
      result = result.filter(
        (o) => (hubAssignments[o.id]?.riders?.length || 0) > 0,
      );
    else if (status === "No Riders")
      result = result.filter(
        (o) => (hubAssignments[o.id]?.riders?.length || 0) === 0,
      );
    setFilteredOutlets(result);
  };
  const handleStatusFilter = (e) => {
    setFilterStatus(e.target.value);
    applyFilters(e.target.value, filterRegion, filterCoordinator);
  };
  const handleRegionFilter = (e) => {
    setFilterRegion(e.target.value);
    applyFilters(filterStatus, e.target.value, filterCoordinator);
  };
  const handleCoordinatorFilter = (e) => {
    setFilterCoordinator(e.target.value);
    applyFilters(filterStatus, filterRegion, e.target.value);
  };

  // Unique, sorted list of hub coordinators for the dropdown
  const coordinatorOptions = Array.from(
    new Set(
      OUTLET_DATA.map((o) => o.coordinator).filter((c) => c && c.trim() !== ""),
    ),
  ).sort();

  const handleOpenHub = (row) => {
    const hData = hubAssignments[row.id] || { riders: [] };
    const assignedCoord = spxCoordinators.find((c) =>
      Array.isArray(c.outlet)
        ? c.outlet.some(
            (o) => o.trim().toLowerCase() === row.outlet.trim().toLowerCase(),
          )
        : c.outlet?.trim().toLowerCase() === row.outlet.trim().toLowerCase(),
    );
    setSelectedHub(row);
    setHubRiders(
      hData.riders.map((r) => ({ ...r, _isNew: false, _toRemove: false })),
    );
    setAssignedCoordId(assignedCoord?._id || "");
    setCoordStatus("Active");
    setAddRiderId("");
    setAddDeployDate(todayISO());
    setSaveError("");
    setIsEditing(false);
    setOpenHubModal(true);
  };

  const handleCloseHubModal = () => {
    setOpenHubModal(false);
    setSelectedHub(null);
    setIsEditing(false);
    setAddRiderId("");
    setSaveError("");
  };

  const handleAddRider = () => {
    if (!addRiderId) {
      setSaveError("Please select a rider to add.");
      return;
    }
    if (hubRiders.find((r) => r.employeeId === addRiderId)) {
      setSaveError("This rider is already in this hub.");
      return;
    }
    const emp = allSpxData.find((e) => e._id === addRiderId);
    if (!emp) return;
    setHubRiders((prev) => [
      ...prev,
      {
        employeeId: emp._id,
        employeeName: `${emp.firstName} ${emp.lastName}`,
        position: emp.position,
        deployStatus: "Deployed",
        deployDate: addDeployDate,
        undeployDate: null,
        _isNew: true,
        _toRemove: false,
      },
    ]);
    setAddRiderId("");
    setAddDeployDate(todayISO());
    setSaveError("");
  };

  const handleMarkRemove = (empId) => {
    setHubRiders((prev) =>
      prev.map((r) =>
        r.employeeId === empId ? { ...r, _toRemove: !r._toRemove } : r,
      ),
    );
  };

  const handleUpdateDeployDate = (empId, date) => {
    setHubRiders((prev) =>
      prev.map((r) =>
        r.employeeId === empId ? { ...r, deployDate: date } : r,
      ),
    );
  };

  const handleUpdateUndeployDate = (empId, date) => {
    setHubRiders((prev) =>
      prev.map((r) =>
        r.employeeId === empId ? { ...r, undeployDate: date } : r,
      ),
    );
  };

  // ── Status change — clears the irrelevant date automatically ─────────────
  const handleUpdateStatus = (employeeId, newStatus) => {
    setHubRiders((prev) =>
      prev.map((r) => {
        if (r.employeeId !== employeeId) return r;
        const isUndeploy = UNDEPLOY_STATUSES.includes(newStatus);
        const isDeploy = DEPLOY_STATUSES.includes(newStatus);
        return {
          ...r,
          deployStatus: newStatus,
          // When switching to an undeploy status → clear deployDate, keep/set undeployDate
          // When switching to a deploy status   → clear undeployDate, keep/set deployDate
          deployDate: isUndeploy ? null : r.deployDate || addDeployDate,
          undeployDate: isDeploy ? null : r.undeployDate || todayISO(),
        };
      }),
    );
  };

  function resolveEmployeeStatus(deployStatus) {
    switch (deployStatus) {
      case "Deployed":
        return "Active";
      case "Shadowing training":
        return "Active";
      case "Resigned":
        return "Inactive";
      case "AWOL":
        return "Inacitve";
      case "Inactive":
        return "Inactive"; // still employed, just not deployed
      default:
        return "Active";
    }
  }

  // ── Save — pushes deployStatus, remarks AND status to DB ─────────────────
  const handleSave = async () => {
    setSaveError("");
    try {
      const adminFullName = localStorage.getItem("adminFullName");
      const adminRole = localStorage.getItem("roleAccount"); // ← add this
      const today = todayISO();

      // 1. Remove riders marked for removal
      for (const r of hubRiders.filter((r) => r._toRemove && !r._isNew)) {
        await axios.put("https://api-map.bmphrc.com/remove-outlet-assignment", {
          outletName: selectedHub.outlet,
          employeeId: r.employeeId,
          remarks: "Resigned",
          dateResigned: today,
          updatedBy: adminFullName,
          updatedByRole: adminRole, // ← add
        });
      }

      // 2. Add new riders
      for (const r of hubRiders.filter((r) => r._isNew && !r._toRemove)) {
        const isUndeploy = UNDEPLOY_STATUSES.includes(r.deployStatus);
        const { status, remarks } = resolveEmployeeFields(r.deployStatus);

        await axios.put("https://api-map.bmphrc.com/assign-outlet-spx", {
          outletName: selectedHub.outlet,
          region: selectedHub.region,
          employeeId: r.employeeId,
          deployStatus: r.deployStatus || "Deployed",
          deployDate: !isUndeploy ? r.deployDate || today : null,
          undeployDate: isUndeploy ? r.undeployDate || today : null,
          updatedBy: adminFullName,
          updatedByRole: adminRole, // ← add
        });

        await axios.put("https://api-map.bmphrc.com/update-employee-status", {
          employeeId: r.employeeId,
          status: resolveEmployeeStatus(r.deployStatus),
          updatedBy: adminFullName,
          updatedByRole: adminRole, // ← add
        });

        await axios.put("https://api-map.bmphrc.com/update-employee-remarks", {
          employeeId: r.employeeId,
          status,
          remarks,
          updatedBy: adminFullName,
          updatedByRole: adminRole, // ← add
        });
      }

      // 3. Update existing riders
      for (const r of hubRiders.filter((r) => !r._isNew && !r._toRemove)) {
        const isUndeploy = UNDEPLOY_STATUSES.includes(r.deployStatus);
        const { status, remarks } = resolveEmployeeFields(r.deployStatus);

        await axios.put("https://api-map.bmphrc.com/assign-outlet-spx", {
          outletName: selectedHub.outlet,
          region: selectedHub.region,
          employeeId: r.employeeId,
          deployStatus: r.deployStatus,
          deployDate: !isUndeploy ? r.deployDate || null : null,
          undeployDate: isUndeploy ? r.undeployDate || null : null,
          updatedBy: adminFullName,
          updatedByRole: adminRole, // ← add
        });

        await axios.put("https://api-map.bmphrc.com/update-employee-status", {
          employeeId: r.employeeId,
          status: resolveEmployeeStatus(r.deployStatus),
          updatedBy: adminFullName,
          updatedByRole: adminRole, // ← add
        });

        await axios.put("https://api-map.bmphrc.com/update-employee-remarks", {
          employeeId: r.employeeId,
          status,
          remarks,
          updatedBy: adminFullName,
          updatedByRole: adminRole, // ← add
        });
      }

      // 4. Coordinator
      if (assignedCoordId) {
        await axios.put(
          "https://api-map.bmphrc.com/assign-coordinator-outlet",
          {
            adminUserId: assignedCoordId,
            outletName: selectedHub.outlet,
            updatedBy: adminFullName,
            updatedByRole: adminRole, // ← add
          },
        );
      }

      const [, coordRes] = await Promise.all([
        fetchAndApply(),
        axios.post("https://api-map.bmphrc.com/get-coordinators"),
      ]);
      setSpxCoordinators(coordRes.data.data);
      await fetchAndApply();
      alert("Hub assignment updated successfully!");
      handleCloseHubModal();
    } catch (err) {
      console.error("Error saving:", err);
      setSaveError("Failed to save. Please try again.");
    }
  };

  const availableRiders = allSpxData.filter(
    (e) =>
      e.status?.toLowerCase() === "active" &&
      !["Tactical Coordinator", "Account Coordinator"].includes(e.position) &&
      !hubRiders.find((r) => r.employeeId === e._id),
  );

  // Two pools for the Add-Rider dropdowns (both exclude riders already on THIS hub):
  //  • floatingPool → no hub assignment (uses the app's existing floatingRiders)
  //  • assignedPool → already assigned to some hub (emp.outlet has a value)
  const floatingPool = floatingRiders.filter(
    (e) => !hubRiders.find((r) => r.employeeId === e._id),
  );
  const assignedPool = availableRiders.filter(
    (e) => e.outlet && String(e.outlet).trim() !== "",
  );

  const totalRiders = activeRiders.length;
  const deployedRiders = activeRiders.filter(
    (r) => r.deployStatus === "Deployed",
  ).length;
  const hubsWithRiders = Object.values(hubAssignments).filter(
    (h) => h.riders.length > 0,
  ).length;

  // ── SPX Dashboard categories (computed from the full SPX population) ──────
  // Helpers for case-insensitive matching.
  const _norm = (v) => (v == null ? "" : String(v).trim().toLowerCase());
  const _isActive = (e) => _norm(e.status) === "active";
  const _isInactive = (e) => _norm(e.status) === "inactive";
  // exclude coordinators from rider counts (same rule used elsewhere)
  const _isRider = (e) =>
    !["Tactical Coordinator", "Account Coordinator"].includes(e.position);

  const spxRiders = allSpxData.filter(_isRider);

  // Total Active Rider — riders whose status is Active
  const totalActiveRiders = spxRiders.filter(_isActive).length;

  // Account Created / Account Modify — Active riders by their riderstatus
  const accountCreatedCount = spxRiders.filter(
    (e) => _isActive(e) && _norm(e.riderstatus) === "account created",
  ).length;
  const accountModifyCount = spxRiders.filter(
    (e) => _isActive(e) && _norm(e.riderstatus) === "account modification",
  ).length;

  // Deployed — Active riders currently deployed
  const deployedCount = spxRiders.filter(
    (e) => _isActive(e) && _norm(e.deployStatus) === "deployed",
  ).length;

  // In Process — riders not yet placed in a hub (was "Pending")
  const inProcessCount = floatingRiders.length;

  // Undeployed — Inactive with remarks = Backout
  const undeployedCount = spxRiders.filter(
    (e) => _isInactive(e) && _norm(e.remarks).includes("back out"),
  ).length;

  // Inactive — Inactive with remarks = Resigned / Terminated / AWOL
  const inactiveCount = spxRiders.filter((e) => {
    if (!_isInactive(e)) return false;
    const r = _norm(e.remarks);
    return (
      r.includes("resigned") || r.includes("terminated") || r.includes("awol")
    );
  }).length;

  const statusColors = {
    Deployed: "#2e7d32",
    Inactive: "#d34005",
    AWOL: "#ed6c02",
    Resigned: "#d32f2f",
    "Shadowing training": "#1976d2",
  };

  // ── Columns ───────────────────────────────────────────────────────────────
  const columns = [
    {
      field: "count",
      headerName: "#",
      width: 55,
      headerAlign: "center",
      align: "center",
    },
    {
      field: "region",
      headerName: "Region",
      width: 155,
      renderCell: (p) => {
        const cfg = REGION_COLORS[p.row.region] || {
          bg: "#f5f5f5",
          color: "#666",
        };
        return (
          <Chip
            label={p.row.region}
            size="small"
            sx={{
              fontWeight: 600,
              fontSize: "11px",
              backgroundColor: cfg.bg,
              color: cfg.color,
              border: `1px solid ${cfg.color}40`,
            }}
          />
        );
      },
    },
    { field: "outlet", headerName: "Hub", width: 250 },
    {
      field: "riderCount",
      headerName: "Riders",
      width: 85,
      headerAlign: "center",
      align: "center",
      renderCell: (p) => {
        const count = p.row._riderCount;
        return (
          <Box
            sx={{
              display: "flex",
              alignItems: "center",
              justifyContent: "center",
              height: "100%",
            }}
          >
            <Chip
              icon={<TwoWheelerIcon sx={{ fontSize: "13px !important" }} />}
              label={count}
              size="small"
              sx={{
                fontWeight: 700,
                minWidth: 50,
                backgroundColor: count > 0 ? SPX_BLUE : "#f5f5f5",
                color: count > 0 ? "white" : "#888",
                "& .MuiChip-icon": { color: count > 0 ? "white" : "#aaa" },
              }}
            />
          </Box>
        );
      },
    },
    {
      field: "deployedCount",
      headerName: "Deployed",
      width: 95,
      headerAlign: "center",
      align: "center",
      renderCell: (p) => {
        const count = p.row._deployedCount;
        return (
          <Box
            sx={{
              display: "flex",
              alignItems: "center",
              justifyContent: "center",
              height: "100%",
            }}
          >
            <Chip
              label={count}
              size="small"
              color={count > 0 ? "success" : "default"}
              sx={{ fontWeight: 700, minWidth: 40 }}
            />
          </Box>
        );
      },
    },
    {
      field: "riderNames",
      headerName: "Assigned Riders",
      flex: 0.6,
      minWidth: 220,
      maxWidth: 320,
      align: "center",
      headerAlign: "center",
      renderCell: (p) => {
        const rList = p.row._riders || [];
        if (rList.length === 0)
          return (
            <Box
              sx={{
                display: "flex",
                alignItems: "center",
                justifyContent: "center",
                height: "100%",
                width: "100%",
              }}
            >
              <Typography
                variant="body2"
                color="text.secondary"
                sx={{ fontStyle: "italic", fontSize: "12px" }}
              >
                No riders assigned
              </Typography>
            </Box>
          );
        return (
          <Box
            sx={{
              display: "flex",
              flexDirection: "column",
              justifyContent: "center",
              alignItems: "center",
              height: "100%",
              width: "100%",
              gap: 0.35,
              py: 0.5,
            }}
          >
            {rList.slice(0, 3).map((r, i) => (
              <Box
                key={i}
                sx={{
                  display: "flex",
                  alignItems: "center",
                  justifyContent: "center",
                  gap: 0.5,
                }}
              >
                <TwoWheelerIcon
                  sx={{
                    fontSize: 11,
                    color: statusColors[r.deployStatus] || "#2e7d32",
                  }}
                />
                <Typography
                  variant="caption"
                  sx={{ fontSize: "11px", fontWeight: 500 }}
                >
                  {r.employeeName}
                </Typography>
                <Chip
                  label={r.deployStatus || "Inactive"}
                  size="small"
                  sx={{
                    height: 13,
                    fontSize: "12px",
                    fontWeight: 600,
                    backgroundColor: statusColors[r.deployStatus]
                      ? `${statusColors[r.deployStatus]}15`
                      : "#2e7d32",
                    color: statusColors[r.deployStatus] || "#ffffff",
                  }}
                />
              </Box>
            ))}
            {rList.length > 3 && (
              <Typography
                variant="caption"
                sx={{ fontSize: "10px", color: "#999", fontStyle: "italic" }}
              >
                +{rList.length - 3} more…
              </Typography>
            )}
          </Box>
        );
      },
    },
    {
      field: "coordinator",
      headerName: "Coordinator",
      width: 175,
      renderCell: (p) => (
        <Box sx={{ display: "flex", alignItems: "center", height: "100%" }}>
          {p.row._coordName ? (
            <Typography variant="body2" sx={{ fontWeight: 500 }}>
              {p.row._coordName}
            </Typography>
          ) : (
            <Typography
              variant="body2"
              color="text.secondary"
              sx={{ fontStyle: "italic" }}
            >
              No coordinator
            </Typography>
          )}
        </Box>
      ),
    },
    {
      field: "action",
      headerName: "Action",
      width: 85,
      sortable: false,
      headerAlign: "center",
      align: "center",
      renderCell: (p) => (
        <Tooltip title="View / Edit Hub">
          <span>
            <IconButton
              color="primary"
              size="small"
              onClick={() => handleOpenHub(p.row)}
              sx={{ "&:hover": { backgroundColor: `rgba(232,54,13,0.1)` } }}
            >
              <EditIcon />
            </IconButton>
          </span>
        </Tooltip>
      ),
    },
  ];

  const rows = filteredOutlets
    .map((outlet, index) => {
      const hData = hubAssignments[outlet.id] || { riders: [] };
      const coord = spxCoordinators.find((c) =>
        Array.isArray(c.outlet)
          ? c.outlet.some(
              (o) =>
                o.trim().toLowerCase() === outlet.outlet.trim().toLowerCase(),
            )
          : c.outlet?.trim().toLowerCase() ===
            outlet.outlet.trim().toLowerCase(),
      );
      return {
        ...outlet,
        count: index + 1,
        _riderCount: hData.riders.length,
        _deployedCount: hData.riders.filter(
          (r) => r.deployStatus === "Deployed",
        ).length,
        _riders: hData.riders,
        _coordName: outlet.coordinator || "",
        _coordStatus: outlet.coordinator ? "Active" : "",
      };
    })
    .filter((row) => {
      const q = searchText.trim().toLowerCase();
      if (!q) return true;
      // Build a searchable string: hub, region, coordinator, and every
      // rider's name + status inside this hub.
      const riderText = (row._riders || [])
        .map((r) => `${r.employeeName || ""} ${r.deployStatus || ""}`)
        .join(" ");
      const haystack = [
        row.outlet, // hub name
        row.region,
        row._coordName, // coordinator
        riderText, // all rider names + statuses in this hub
      ]
        .filter(Boolean)
        .join(" ")
        .toLowerCase();
      return haystack.includes(q);
    });

  const handleExportHubs = () => {
    const headers = [
      "#",
      "Region",
      "Hub",
      "Total Riders",
      "Deployed",
      "Assigned Riders",
      "Coordinator",
    ];

    const exportRows = OUTLET_DATA.map((outlet, index) => {
      const hData = hubAssignments[outlet.id] || { riders: [] };

      const riderLines = hData.riders.length
        ? hData.riders
            .map((r) => `${r.employeeName} (${r.deployStatus || "Inactive"})`)
            .join("\n")
        : "No riders assigned";

      const deployedCount = hData.riders.filter(
        (r) => r.deployStatus === "Deployed",
      ).length;

      return {
        count: index + 1,
        region: outlet.region,
        hub: outlet.outlet,
        totalRiders: hData.riders.length,
        deployed: deployedCount,
        assignedRiders: riderLines,
        coordinator: outlet.coordinator || "—",
      };
    });

    const wb = XLSX.utils.book_new();
    const ws = XLSX.utils.json_to_sheet([]);

    XLSX.utils.sheet_add_aoa(ws, [headers], { origin: "A1" });
    XLSX.utils.sheet_add_json(ws, exportRows, {
      origin: "A2",
      skipHeader: true,
    });

    // ── Column widths ───────────────────────────────────────────────────
    ws["!cols"] = [
      { wch: 5 }, // #
      { wch: 18 }, // Region
      { wch: 28 }, // Hub
      { wch: 14 }, // Total Riders
      { wch: 12 }, // Deployed
      { wch: 40 }, // Assigned Riders — fixed width, wraps vertically
      { wch: 22 }, // Coordinator
    ];

    // ── Row heights — taller rows for hubs with many riders ────────────
    // Row 0 = header (index 0), data starts at index 1
    ws["!rows"] = [
      { hpt: 20 }, // header row
      ...exportRows.map((r) => {
        const lineCount = r.assignedRiders.split("\n").length;
        return { hpt: Math.max(18, lineCount * 16) }; // 16pt per rider line
      }),
    ];

    // ── Wrap + vertical-align every data cell in the Assigned Riders col ─
    exportRows.forEach((_, rowIdx) => {
      const cellAddr = XLSX.utils.encode_cell({ r: rowIdx + 1, c: 5 }); // col F
      if (ws[cellAddr]) {
        ws[cellAddr].s = {
          alignment: { wrapText: true, vertical: "top" },
        };
      }
    });

    // ── Header styles ───────────────────────────────────────────────────
    headers.forEach((_, c) => {
      const addr = XLSX.utils.encode_cell({ r: 0, c });
      if (ws[addr])
        ws[addr].s = {
          font: { bold: true },
          fill: { fgColor: { rgb: "F8FAFC" } },
          alignment: { horizontal: "center", vertical: "center" },
          border: { bottom: { style: "thin", color: { rgb: "E2E8F0" } } },
        };
    });

    XLSX.utils.book_append_sheet(wb, ws, "SPX Hubs");

    const buffer = XLSX.write(wb, { type: "array", bookType: "xlsx" });
    const blob = new Blob([buffer], {
      type: "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet",
    });
    const link = document.createElement("a");
    link.href = URL.createObjectURL(blob);
    link.download = `SPX_Hubs_${new Date().toISOString().split("T")[0]}.xlsx`;
    document.body.appendChild(link);
    link.click();
    link.remove();
  };

  // ══════════════════════════════════════════════════════════════════════════
  return (
    <>
      <Topbar />
      <Sidebar />
      <Box
        sx={{
          marginLeft: { xs: 0, md: sidebarOpen ? "280px" : "70px" },
          transition: "margin-left 0.3s ease",
          minHeight: "100vh",
          backgroundColor: "#f5f7fa",
          paddingTop: "64px",
        }}
      >
        <Box sx={{ p: 3, maxWidth: "1800px", margin: "0 auto" }}>
          {/* ── Header ── */}
          <Paper
            elevation={0}
            sx={{
              p: 3,
              mb: 3,
              background: `linear-gradient(135deg, ${SPX_BLUE} 0%, ${SPX_DARK} 100%)`,
              borderRadius: "12px",
            }}
          >
            <Box
              sx={{
                display: "flex",
                alignItems: "center",
                justifyContent: "space-between",
                flexWrap: "wrap",
                gap: 2,
              }}
            >
              <Box sx={{ display: "flex", alignItems: "center", gap: 2 }}>
                <Avatar
                  src={SPXlogo}
                  alt="SPX Logo"
                  sx={{
                    width: 80,
                    height: 80,
                    "& img": { objectFit: "contain" },
                  }}
                >
                  <BusinessIcon sx={{ fontSize: 32, color: "white" }} />
                </Avatar>
                <Box>
                  <Typography
                    variant="h4"
                    sx={{ color: "white", fontWeight: 700, mb: 0.5 }}
                  >
                    HUB LIST
                  </Typography>
                  <Typography
                    variant="body1"
                    sx={{ color: "rgba(255,255,255,0.9)" }}
                  >
                    SPX EXPRESS — All Regions
                  </Typography>
                </Box>
              </Box>
            </Box>
          </Paper>

          {/* ── Dashboard Stat Cards (full-width responsive grid) ── */}
          <Box
            sx={{
              display: "grid",
              gridTemplateColumns: {
                xs: "repeat(2, 1fr)",
                sm: "repeat(3, 1fr)",
                md: "repeat(3, 1fr)",
                lg: "repeat(9, 1fr)",
              },
              gap: 1.5,
              mb: 3,
            }}
          >
            {[
              {
                label: "Total Hubs",
                value: OUTLET_DATA.length,
                color: "#0f2a44",
                accent: "#90e0ef",
              },
              {
                label: "Total Active Hubs",
                value: hubsWithRiders,
                color: "#0f2a44",
                accent: "#90e0ef",
              },
              {
                label: "Total Active Rider",
                value: totalActiveRiders,
                color: "#1565c0",
                accent: "#64b5f6",
              },
              {
                label: "Account Created",
                value: accountCreatedCount,
                color: "#2e7d32",
                accent: "#81c784",
              },
              {
                label: "Account Modify",
                value: accountModifyCount,
                color: "#00838f",
                accent: "#4dd0e1",
              },
              {
                label: "Deployed",
                value: deployedCount,
                color: "#2e7d32",
                accent: "#81c784",
              },
              {
                label: "In Process",
                value: inProcessCount,
                color: "#ef6c00",
                accent: "#ffb74d",
              },
              {
                label: "Inactive",
                value: inactiveCount,
                color: "#c62828",
                accent: "#e57373",
              },
              {
                label: "Undeployed",
                value: undeployedCount,
                color: "#6a1b9a",
                accent: "#ba68c8",
              },
            ].map((s) => (
              <Paper
                key={s.label}
                elevation={0}
                sx={{
                  position: "relative",
                  overflow: "hidden",
                  borderRadius: "12px",
                  border: "1px solid #e8e8e8",
                  p: 2,
                  display: "flex",
                  flexDirection: "column",
                  alignItems: "center",
                  justifyContent: "center",
                  minHeight: 96,
                  transition: "transform 0.15s ease, box-shadow 0.15s ease",
                  "&:hover": {
                    transform: "translateY(-2px)",
                    boxShadow: "0 6px 18px rgba(0,0,0,0.08)",
                  },
                  "&::before": {
                    content: '""',
                    position: "absolute",
                    top: 0,
                    left: 0,
                    right: 0,
                    height: "4px",
                    backgroundColor: s.accent,
                  },
                }}
              >
                <Typography
                  sx={{
                    color: s.color,
                    fontWeight: 800,
                    fontSize: "28px",
                    lineHeight: 1.1,
                  }}
                >
                  {s.value}
                </Typography>
                <Typography
                  sx={{
                    color: "#666",
                    fontSize: "11px",
                    fontWeight: 600,
                    textAlign: "center",
                    mt: 0.5,
                    textTransform: "uppercase",
                    letterSpacing: "0.3px",
                  }}
                >
                  {s.label}
                </Typography>
              </Paper>
            ))}
          </Box>

          {/* ── Filter Bar ── */}
          <Paper
            elevation={0}
            sx={{
              p: 2.5,
              mb: 3,
              borderRadius: "12px",
              border: "1px solid #e0e0e0",
            }}
          >
            <Box
              sx={{
                display: "flex",
                flexWrap: "wrap",
                alignItems: "center",
                gap: 2,
              }}
            >
              <FormControl sx={{ minWidth: 200 }}>
                <InputLabel>Filter by Region</InputLabel>
                <Select
                  value={filterRegion}
                  onChange={handleRegionFilter}
                  label="Filter by Region"
                  sx={{ backgroundColor: "white", borderRadius: "8px" }}
                  startAdornment={
                    <LocationOnIcon
                      sx={{ color: "#bbb", mr: 1, fontSize: 20 }}
                    />
                  }
                >
                  <MenuItem value="ALL">All Regions</MenuItem>
                  {Object.keys(HUBS_BY_REGION).map((r) => (
                    <MenuItem key={r} value={r}>
                      <Box
                        sx={{ display: "flex", alignItems: "center", gap: 1 }}
                      >
                        <Box
                          sx={{
                            width: 10,
                            height: 10,
                            borderRadius: "50%",
                            backgroundColor: REGION_COLORS[r]?.color || "#888",
                          }}
                        />
                        {r}
                      </Box>
                    </MenuItem>
                  ))}
                </Select>
              </FormControl>
              <FormControl sx={{ minWidth: 200 }}>
                <InputLabel>Filter by Riders</InputLabel>
                <Select
                  value={filterStatus}
                  onChange={handleStatusFilter}
                  label="Filter by Riders"
                  sx={{ backgroundColor: "white", borderRadius: "8px" }}
                  startAdornment={
                    <FilterListIcon
                      sx={{ color: "#bbb", mr: 1, fontSize: 20 }}
                    />
                  }
                >
                  <MenuItem value="ALL">All Hubs</MenuItem>
                  <MenuItem value="Has Riders">Has Riders</MenuItem>
                  <MenuItem value="No Riders">No Riders</MenuItem>
                </Select>
              </FormControl>
              <FormControl sx={{ minWidth: 200 }}>
                <InputLabel>Filter by Coordinator</InputLabel>
                <Select
                  value={filterCoordinator}
                  onChange={handleCoordinatorFilter}
                  label="Filter by Coordinator"
                  sx={{ backgroundColor: "white", borderRadius: "8px" }}
                  startAdornment={
                    <FilterListIcon
                      sx={{ color: "#bbb", mr: 1, fontSize: 20 }}
                    />
                  }
                >
                  <MenuItem value="ALL">All Coordinators</MenuItem>
                  {coordinatorOptions.map((c) => (
                    <MenuItem key={c} value={c}>
                      {c}
                    </MenuItem>
                  ))}
                </Select>
              </FormControl>
              <Box sx={{ flexGrow: 1 }} />
              <Box
                sx={{
                  display: "flex",
                  gap: 1.5,
                  flexWrap: "wrap",
                  alignItems: "center",
                }}
              >
                <Button
                  variant="outlined"
                  startIcon={<FileDownloadIcon />}
                  onClick={handleExportHubs}
                  sx={{
                    height: 40,
                    borderColor: SPX_BLUE,
                    color: SPX_BLUE,
                    fontWeight: 600,
                    textTransform: "none",
                    borderRadius: "8px",
                    fontSize: "14px",
                    px: 2.5,
                    "&:hover": {
                      backgroundColor: "rgba(46,99,133,0.06)",
                      borderColor: SPX_BLUE,
                    },
                  }}
                >
                  Export Hubs
                </Button>
                <Chip
                  icon={<LocationOnIcon />}
                  label={`Showing: ${filteredOutlets.length} hubs`}
                  sx={{
                    height: 40,
                    fontSize: "14px",
                    fontWeight: 600,
                    px: 1,
                    backgroundColor: SPX_BLUE,
                    color: "white",
                    "& .MuiChip-icon": { color: "white" },
                  }}
                />
                <Button
                  variant="contained"
                  startIcon={<PeopleAltIcon />}
                  onClick={() => setOpenSummaryModal(true)}
                  sx={{
                    height: 40,
                    backgroundColor: SPX_DARK,
                    fontWeight: 600,
                    textTransform: "none",
                    borderRadius: "8px",
                    fontSize: "14px",
                    px: 2.5,
                    "&:hover": { backgroundColor: SPX_BLUE },
                  }}
                >
                  Personnel Summary
                </Button>
              </Box>
            </Box>
          </Paper>

          {/* ── DataGrid ── */}
          <Paper
            elevation={0}
            sx={{
              borderRadius: "12px",
              overflow: "hidden",
              border: "1px solid #e0e0e0",
              "& .MuiDataGrid-root": { border: "none" },
              "& .MuiDataGrid-cell": { borderBottom: "1px solid #f0f0f0" },
              "& .MuiDataGrid-columnHeaders": {
                backgroundColor: "#fafafa",
                borderBottom: "2px solid #e0e0e0",
                fontSize: "14px",
                fontWeight: 600,
              },
              "& .MuiDataGrid-row:hover": { backgroundColor: "#f8f9fa" },
            }}
          >
            {/* Search bar — OUTSIDE the grid so it renders and keeps focus */}
            <Box
              sx={{
                p: 2,
                display: "flex",
                justifyContent: "space-between",
                alignItems: "center",
                backgroundColor: "#f8f9fa",
                borderBottom: "2px solid #e0e0e0",
              }}
            >
              <TextField
                size="small"
                placeholder="Search name, SSS, TIN, status…"
                value={searchText}
                onChange={(e) => setSearchText(e.target.value)}
                InputProps={{
                  startAdornment: (
                    <SearchIcon sx={{ color: "#888", mr: 1, fontSize: 20 }} />
                  ),
                  endAdornment: searchText ? (
                    <IconButton
                      size="small"
                      onClick={() => setSearchText("")}
                      sx={{ p: 0.3 }}
                    >
                      <CloseIcon sx={{ fontSize: 18, color: "#888" }} />
                    </IconButton>
                  ) : null,
                }}
                sx={{
                  minWidth: 320,
                  "& .MuiOutlinedInput-root": {
                    backgroundColor: "white",
                    borderRadius: "8px",
                    "& fieldset": { borderColor: "#d0d0d0" },
                    "&:hover fieldset": { borderColor: "#2e6385ff" },
                  },
                }}
              />
            </Box>

            <DataGrid
              rows={rows}
              columns={columns}
              autoHeight
              rowHeight={72}
              initialState={{
                pagination: { paginationModel: { page: 0, pageSize: 20 } },
              }}
              slotProps={{ toolbar: { showQuickFilter: true } }}
              pageSizeOptions={[10, 20, 50, 100]}
              disableRowSelectionOnClick
              disableDensitySelector
              disableColumnFilter
              disableColumnSelector
            />
          </Paper>

          {/* ══════════════════════════════════════════════════════
               HUB DETAIL MODAL
          ══════════════════════════════════════════════════════ */}
          <Modal
            open={openHubModal}
            onClose={handleCloseHubModal}
            closeAfterTransition
            BackdropComponent={Backdrop}
            BackdropProps={{
              timeout: 500,
              sx: { backgroundColor: "rgba(0,0,0,0.7)" },
            }}
          >
            <Fade in={openHubModal}>
              <Box
                sx={{
                  position: "absolute",
                  top: "50%",
                  left: "50%",
                  transform: "translate(-50%,-50%)",
                  width: { xs: "95%", sm: "90%", md: "80%", lg: "72%" },
                  maxHeight: "92vh",
                  overflowY: "auto",
                  bgcolor: "background.paper",
                  borderRadius: "16px",
                  boxShadow: "0 24px 48px rgba(0,0,0,0.2)",
                  "&::-webkit-scrollbar": { width: "8px" },
                  "&::-webkit-scrollbar-track": {
                    background: "#f1f1f1",
                    borderRadius: "10px",
                  },
                  "&::-webkit-scrollbar-thumb": {
                    background: "#888",
                    borderRadius: "10px",
                  },
                }}
              >
                {/* Modal Header */}
                <Box
                  sx={{
                    position: "sticky",
                    top: 0,
                    zIndex: 1,
                    background: `linear-gradient(135deg, ${SPX_BLUE} 0%, ${SPX_DARK} 100%)`,
                    p: 3,
                    borderTopLeftRadius: "16px",
                    borderTopRightRadius: "16px",
                    display: "flex",
                    justifyContent: "space-between",
                    alignItems: "center",
                  }}
                >
                  <Box sx={{ display: "flex", alignItems: "center", gap: 2 }}>
                    <Avatar
                      sx={{
                        bgcolor: "rgba(255,255,255,0.2)",
                        width: 48,
                        height: 48,
                      }}
                    >
                      <TwoWheelerIcon sx={{ color: "white" }} />
                    </Avatar>
                    <Box>
                      <Typography
                        variant="h5"
                        sx={{ color: "white", fontWeight: 700 }}
                      >
                        Hub Assignment
                      </Typography>
                      <Typography
                        variant="body2"
                        sx={{ color: "rgba(255,255,255,0.8)" }}
                      >
                        {isEditing ? "Edit Mode" : "View Mode"}
                      </Typography>
                    </Box>
                  </Box>
                  <IconButton
                    onClick={handleCloseHubModal}
                    sx={{
                      color: "white",
                      "&:hover": { backgroundColor: "rgba(255,255,255,0.1)" },
                    }}
                  >
                    <CloseIcon />
                  </IconButton>
                </Box>

                {selectedHub && (
                  <Box sx={{ p: 4 }}>
                    {/* Hub Info */}
                    <Card
                      elevation={0}
                      sx={{
                        mb: 3,
                        border: "1px solid #e0e0e0",
                        borderRadius: "12px",
                      }}
                    >
                      <CardContent sx={{ p: 3 }}>
                        <Typography
                          variant="h6"
                          sx={{
                            mb: 2,
                            fontWeight: 600,
                            color: SPX_BLUE,
                            display: "flex",
                            alignItems: "center",
                            gap: 1,
                          }}
                        >
                          <BusinessIcon /> Hub Information
                        </Typography>
                        <Grid container spacing={2}>
                          <Grid item xs={12} sm={4}>
                            <TextField
                              label="Account"
                              fullWidth
                              size="small"
                              value={selectedHub.account || ""}
                              InputProps={{ readOnly: true }}
                            />
                          </Grid>
                          <Grid item xs={12} sm={4}>
                            <TextField
                              label="Region"
                              fullWidth
                              size="small"
                              value={selectedHub.region || ""}
                              InputProps={{ readOnly: true }}
                            />
                          </Grid>
                          <Grid item xs={12} sm={4}>
                            <TextField
                              label="Hub"
                              fullWidth
                              size="small"
                              value={selectedHub.outlet || ""}
                              InputProps={{ readOnly: true }}
                            />
                          </Grid>
                        </Grid>
                      </CardContent>
                    </Card>

                    {/* Riders Card */}
                    <Card
                      elevation={0}
                      sx={{
                        mb: 3,
                        border: "1px solid #e0e0e0",
                        borderRadius: "12px",
                      }}
                    >
                      <CardContent sx={{ p: 3 }}>
                        <Box
                          sx={{
                            display: "flex",
                            alignItems: "center",
                            justifyContent: "space-between",
                            mb: 2,
                            flexWrap: "wrap",
                            gap: 1,
                          }}
                        >
                          <Typography
                            variant="h6"
                            sx={{
                              fontWeight: 600,
                              color: SPX_BLUE,
                              display: "flex",
                              alignItems: "center",
                              gap: 1,
                            }}
                          >
                            <TwoWheelerIcon />
                            Assigned Riders
                            <Chip
                              label={`${hubRiders.filter((r) => !r._toRemove).length} rider${hubRiders.filter((r) => !r._toRemove).length !== 1 ? "s" : ""}`}
                              size="small"
                              sx={{
                                ml: 1,
                                backgroundColor: SPX_BLUE,
                                color: "white",
                                fontWeight: 700,
                              }}
                            />
                          </Typography>
                          {!isEditing && canAccessEdit && (
                            <Button
                              variant="outlined"
                              size="small"
                              startIcon={<EditIcon />}
                              onClick={() => setIsEditing(true)}
                              sx={{
                                borderColor: SPX_BLUE,
                                color: SPX_BLUE,
                                fontWeight: 600,
                                textTransform: "none",
                                borderRadius: "8px",
                                "&:hover": {
                                  backgroundColor: "rgba(232,54,13,0.06)",
                                  borderColor: SPX_DARK,
                                },
                              }}
                            >
                              Edit Riders
                            </Button>
                          )}
                        </Box>

                        {hubRiders.length === 0 ? (
                          <Box
                            sx={{
                              textAlign: "center",
                              py: 4,
                              border: "1px dashed #ddd",
                              borderRadius: "10px",
                              backgroundColor: "#fafafa",
                            }}
                          >
                            <TwoWheelerIcon
                              sx={{ fontSize: 40, color: "#ccc", mb: 1 }}
                            />
                            <Typography variant="body2" sx={{ color: "#999" }}>
                              No riders assigned to this hub yet.
                            </Typography>
                          </Box>
                        ) : (
                          <TableContainer
                            component={Paper}
                            elevation={0}
                            sx={{
                              border: "1px solid #e0e0e0",
                              borderRadius: "10px",
                              overflow: "hidden",
                              mb: isEditing ? 2 : 0,
                            }}
                          >
                            <Table size="small">
                              <TableHead>
                                <TableRow sx={{ backgroundColor: "#fafafa" }}>
                                  {/* # */}
                                  <TableCell
                                    sx={{
                                      fontWeight: 700,
                                      fontSize: "12px",
                                      borderBottom: "2px solid #e0e0e0",
                                      width: 40,
                                    }}
                                  >
                                    #
                                  </TableCell>
                                  {/* Name */}
                                  <TableCell
                                    sx={{
                                      fontWeight: 700,
                                      fontSize: "12px",
                                      borderBottom: "2px solid #e0e0e0",
                                    }}
                                  >
                                    Name
                                  </TableCell>
                                  {/* Position */}
                                  <TableCell
                                    sx={{
                                      fontWeight: 700,
                                      fontSize: "12px",
                                      borderBottom: "2px solid #e0e0e0",
                                    }}
                                  >
                                    Position
                                  </TableCell>
                                  {/* Status */}
                                  <TableCell
                                    sx={{
                                      fontWeight: 700,
                                      fontSize: "12px",
                                      borderBottom: "2px solid #e0e0e0",
                                      width: 180,
                                    }}
                                  >
                                    Status
                                  </TableCell>
                                  {/* Deploy Date */}
                                  <TableCell
                                    sx={{
                                      fontWeight: 700,
                                      fontSize: "12px",
                                      borderBottom: "2px solid #e0e0e0",
                                      width: 155,
                                    }}
                                  >
                                    Start Date
                                  </TableCell>
                                  {/* ── NEW: Undeploy Date ── */}
                                  <TableCell
                                    sx={{
                                      fontWeight: 700,
                                      fontSize: "12px",
                                      borderBottom: "2px solid #e0e0e0",
                                      width: 155,
                                    }}
                                  >
                                    End Date
                                  </TableCell>
                                  {/* Remove (edit only) */}
                                  {/* {isEditing && (
                                    <TableCell
                                      sx={{
                                        fontWeight: 700,
                                        fontSize: "12px",
                                        borderBottom: "2px solid #e0e0e0",
                                        width: 70,
                                        textAlign: "center",
                                      }}
                                    >
                                      Remove
                                    </TableCell>
                                  )} */}
                                </TableRow>
                              </TableHead>

                              <TableBody>
                                {hubRiders.map((r, idx) => {
                                  const isUndeployStatus =
                                    UNDEPLOY_STATUSES.includes(r.deployStatus);
                                  const isDeployStatus =
                                    DEPLOY_STATUSES.includes(r.deployStatus);

                                  return (
                                    <TableRow
                                      key={r.employeeId}
                                      sx={{
                                        opacity: r._toRemove ? 0.45 : 1,
                                        backgroundColor: r._toRemove
                                          ? "#ffebee"
                                          : r._isNew
                                            ? "#f0fdf4"
                                            : "white",
                                        "&:last-child td": { borderBottom: 0 },
                                      }}
                                    >
                                      {/* # */}
                                      <TableCell
                                        sx={{ fontSize: "12px", color: "#666" }}
                                      >
                                        {idx + 1}
                                      </TableCell>

                                      {/* Name */}
                                      <TableCell>
                                        <Box
                                          sx={{
                                            display: "flex",
                                            alignItems: "center",
                                            gap: 0.8,
                                          }}
                                        >
                                          <Typography
                                            variant="body2"
                                            sx={{
                                              fontWeight: 600,
                                              fontSize: "12px",
                                              textDecoration: r._toRemove
                                                ? "line-through"
                                                : "none",
                                            }}
                                          >
                                            {r.employeeName}
                                          </Typography>
                                          {r._isNew && !r._toRemove && (
                                            <Chip
                                              label="New"
                                              size="small"
                                              color="success"
                                              sx={{
                                                height: 16,
                                                fontSize: "10px",
                                                fontWeight: 700,
                                              }}
                                            />
                                          )}
                                          {r._toRemove && (
                                            <Chip
                                              label="Will be removed"
                                              size="small"
                                              color="error"
                                              sx={{
                                                height: 16,
                                                fontSize: "9px",
                                                fontWeight: 700,
                                              }}
                                            />
                                          )}
                                        </Box>
                                      </TableCell>

                                      {/* Position */}
                                      <TableCell>
                                        <Typography
                                          variant="caption"
                                          sx={{ color: "#666" }}
                                        >
                                          {r.position || "—"}
                                        </Typography>
                                      </TableCell>

                                      {/* Status dropdown / chip */}
                                      <TableCell>
                                        {isEditing && !r._toRemove ? (
                                          <TextField
                                            select
                                            size="small"
                                            value={r.deployStatus || ""}
                                            onChange={(e) =>
                                              handleUpdateStatus(
                                                r.employeeId,
                                                e.target.value,
                                              )
                                            }
                                            sx={{
                                              minWidth: 170,
                                              "& .MuiInputBase-input": {
                                                fontSize: "12px",
                                                py: 0.6,
                                              },
                                            }}
                                          >
                                            <MenuItem value="">
                                              <em>Select Status</em>
                                            </MenuItem>
                                            <MenuItem value="Shadowing training">
                                              Shadow training
                                            </MenuItem>
                                            <MenuItem value="Deployed">
                                              Deployed
                                            </MenuItem>
                                            <MenuItem value="Inactive">
                                              Inactive
                                            </MenuItem>
                                            <MenuItem value="AWOL">
                                              AWOL
                                            </MenuItem>
                                            <MenuItem value="Resigned">
                                              Resigned
                                            </MenuItem>
                                            <MenuItem value="Terminated">
                                              Terminated
                                            </MenuItem>
                                            <MenuItem value="Back Out">
                                              Back Out
                                            </MenuItem>
                                          </TextField>
                                        ) : (
                                          <Chip
                                            label={r.deployStatus || "Inactive"}
                                            size="small"
                                            sx={{
                                              height: 13,
                                              fontSize: "9px",
                                              fontWeight: 600,
                                              backgroundColor: statusColors[
                                                r.deployStatus
                                              ]
                                                ? `${statusColors[r.deployStatus]}15`
                                                : "#f5f5f5",
                                              color:
                                                statusColors[r.deployStatus] ||
                                                "#888",
                                            }}
                                          />
                                        )}
                                      </TableCell>

                                      {/* Deploy Date — disabled when undeploy status selected */}
                                      <TableCell>
                                        {isEditing && !r._toRemove ? (
                                          <Tooltip
                                            title={
                                              isUndeployStatus
                                                ? "Not applicable for this status"
                                                : ""
                                            }
                                          >
                                            <span>
                                              <TextField
                                                type="date"
                                                size="small"
                                                value={
                                                  r.deployDate
                                                    ? r.deployDate.split("T")[0]
                                                    : ""
                                                }
                                                InputLabelProps={{
                                                  shrink: true,
                                                }}
                                                disabled={isUndeployStatus}
                                                onChange={(e) =>
                                                  handleUpdateDeployDate(
                                                    r.employeeId,
                                                    e.target.value,
                                                  )
                                                }
                                                sx={{
                                                  "& .MuiInputBase-input": {
                                                    fontSize: "12px",
                                                    py: 0.6,
                                                  },
                                                  width: 145,
                                                  opacity: isUndeployStatus
                                                    ? 0.38
                                                    : 1,
                                                }}
                                              />
                                            </span>
                                          </Tooltip>
                                        ) : (
                                          <Typography
                                            variant="caption"
                                            sx={{ color: "#2e7d32" }}
                                          >
                                            {formatDate(r.deployDate)}
                                          </Typography>
                                        )}
                                      </TableCell>

                                      {/* ── Undeploy Date — disabled when deploy status selected ── */}
                                      <TableCell>
                                        {isEditing && !r._toRemove ? (
                                          <Tooltip
                                            title={
                                              isDeployStatus
                                                ? "Not applicable for this status"
                                                : ""
                                            }
                                          >
                                            <span>
                                              <TextField
                                                type="date"
                                                size="small"
                                                value={
                                                  r.undeployDate
                                                    ? r.undeployDate.split(
                                                        "T",
                                                      )[0]
                                                    : ""
                                                }
                                                InputLabelProps={{
                                                  shrink: true,
                                                }}
                                                disabled={isDeployStatus}
                                                onChange={(e) =>
                                                  handleUpdateUndeployDate(
                                                    r.employeeId,
                                                    e.target.value,
                                                  )
                                                }
                                                sx={{
                                                  "& .MuiInputBase-input": {
                                                    fontSize: "12px",
                                                    py: 0.6,
                                                  },
                                                  width: 145,
                                                  opacity: isDeployStatus
                                                    ? 0.38
                                                    : 1,
                                                }}
                                              />
                                            </span>
                                          </Tooltip>
                                        ) : (
                                          <Typography
                                            variant="caption"
                                            sx={{
                                              color: r.undeployDate
                                                ? "#d34005"
                                                : "#bbb",
                                            }}
                                          >
                                            {formatDate(r.undeployDate)}
                                          </Typography>
                                        )}
                                      </TableCell>

                                      {/* Remove button */}
                                      {/* {isEditing && (
                                        <TableCell sx={{ textAlign: "center" }}>
                                          <Tooltip
                                            title={
                                              r._toRemove ? "Undo" : "Remove"
                                            }
                                          > */}
                                      {/* <IconButton
                                              size="small"
                                              onClick={() =>
                                                handleMarkRemove(r.employeeId)
                                              }
                                              sx={{
                                                color: r._toRemove
                                                  ? "#2e7d32"
                                                  : "#e53935",
                                                "&:hover": {
                                                  backgroundColor: r._toRemove
                                                    ? "#f0fdf4"
                                                    : "#ffebee",
                                                },
                                              }}
                                            >
                                              <RemoveCircleOutlineIcon fontSize="small" />
                                            </IconButton> */}
                                      {/* </Tooltip>
                                        </TableCell>
                                      )} */}
                                    </TableRow>
                                  );
                                })}
                              </TableBody>
                            </Table>
                          </TableContainer>
                        )}

                        {/* Add Rider */}
                        {isEditing && (
                          <Box
                            sx={{
                              border: "1.5px dashed #ccc",
                              borderRadius: "10px",
                              p: 2.5,
                              backgroundColor: "#fafafa",
                              mt: 2,
                            }}
                          >
                            <Typography
                              variant="body2"
                              sx={{
                                fontWeight: 600,
                                mb: 1.5,
                                color: "#444",
                                display: "flex",
                                alignItems: "center",
                                gap: 0.8,
                              }}
                            >
                              <AddIcon sx={{ fontSize: 18, color: SPX_BLUE }} />{" "}
                              Add Rider to Hub
                            </Typography>
                            <Grid container spacing={2} alignItems="flex-end">
                              <Grid item xs={12} sm={6} md={3}>
                                <Autocomplete
                                  size="small"
                                  options={assignedPool}
                                  value={
                                    assignedPool.find(
                                      (emp) => emp._id === addRiderId,
                                    ) || null
                                  }
                                  getOptionLabel={(emp) =>
                                    emp
                                      ? `${emp.firstName} ${emp.lastName}`
                                      : ""
                                  }
                                  isOptionEqualToValue={(opt, val) =>
                                    opt._id === val._id
                                  }
                                  onChange={(event, picked) => {
                                    setAddRiderId(picked?._id || "");
                                    setSaveError("");
                                  }}
                                  noOptionsText="No assigned riders"
                                  renderOption={(props, emp) => (
                                    <Box
                                      component="li"
                                      {...props}
                                      key={emp._id}
                                    >
                                      <Box>
                                        <Typography
                                          variant="body2"
                                          sx={{
                                            fontWeight: 600,
                                            fontSize: "13px",
                                          }}
                                        >
                                          {emp.firstName} {emp.lastName}
                                        </Typography>
                                        <Typography
                                          variant="caption"
                                          sx={{ color: "#888" }}
                                        >
                                          {emp.position || "No position"}
                                          {emp.region ? ` · ${emp.region}` : ""}
                                          {emp.outlet ? ` · ${emp.outlet}` : ""}
                                        </Typography>
                                      </Box>
                                    </Box>
                                  )}
                                  renderInput={(params) => (
                                    <TextField
                                      {...params}
                                      label="Riders With hub"
                                    />
                                  )}
                                />
                              </Grid>
                              <Grid item xs={12} sm={6} md={3}>
                                <Autocomplete
                                  size="small"
                                  options={floatingPool}
                                  value={
                                    floatingPool.find(
                                      (emp) => emp._id === addRiderId,
                                    ) || null
                                  }
                                  getOptionLabel={(emp) =>
                                    emp
                                      ? `${emp.firstName} ${emp.lastName}`
                                      : ""
                                  }
                                  isOptionEqualToValue={(opt, val) =>
                                    opt._id === val._id
                                  }
                                  onChange={(event, picked) => {
                                    setAddRiderId(picked?._id || "");
                                    setSaveError("");
                                  }}
                                  noOptionsText="No floating riders"
                                  renderOption={(props, emp) => (
                                    <Box
                                      component="li"
                                      {...props}
                                      key={emp._id}
                                    >
                                      <Box>
                                        <Typography
                                          variant="body2"
                                          sx={{
                                            fontWeight: 600,
                                            fontSize: "13px",
                                          }}
                                        >
                                          {emp.firstName} {emp.lastName}
                                        </Typography>
                                        <Typography
                                          variant="caption"
                                          sx={{ color: "#888" }}
                                        >
                                          {emp.position || "No position"}
                                          {emp.region ? ` · ${emp.region}` : ""}
                                          {" · No hub"}
                                        </Typography>
                                      </Box>
                                    </Box>
                                  )}
                                  renderInput={(params) => (
                                    <TextField
                                      {...params}
                                      label="Floating Riders"
                                      placeholder="No hub…"
                                    />
                                  )}
                                />
                              </Grid>
                              <Grid item xs={12} sm={6} md={3}>
                                <TextField
                                  label="Deploy Date"
                                  type="date"
                                  fullWidth
                                  size="small"
                                  value={addDeployDate}
                                  InputLabelProps={{ shrink: true }}
                                  onChange={(e) =>
                                    setAddDeployDate(e.target.value)
                                  }
                                  InputProps={{
                                    startAdornment: (
                                      <EventIcon
                                        sx={{
                                          fontSize: 16,
                                          color: "#2e7d32",
                                          mr: 0.5,
                                        }}
                                      />
                                    ),
                                  }}
                                />
                              </Grid>
                              <Grid item xs={12} sm={6} md={3}>
                                <Button
                                  fullWidth
                                  variant="contained"
                                  startIcon={<AddIcon />}
                                  onClick={handleAddRider}
                                  disabled={!addRiderId}
                                  sx={{
                                    backgroundColor: SPX_BLUE,
                                    fontWeight: 600,
                                    textTransform: "none",
                                    borderRadius: "8px",
                                    "&:hover": { backgroundColor: SPX_DARK },
                                    "&.Mui-disabled": {
                                      backgroundColor: "#b0bec5",
                                      color: "white",
                                    },
                                  }}
                                >
                                  Add Rider
                                </Button>
                              </Grid>
                            </Grid>
                          </Box>
                        )}

                        {saveError && (
                          <Alert
                            severity="error"
                            sx={{ mt: 2, borderRadius: "8px" }}
                          >
                            {saveError}
                          </Alert>
                        )}
                      </CardContent>
                    </Card>

                    {/* Action Buttons */}
                    {isEditing && (
                      <Box
                        sx={{
                          display: "flex",
                          gap: 2,
                          justifyContent: "center",
                          pt: 1,
                        }}
                      >
                        <Button
                          variant="contained"
                          startIcon={<SaveIcon />}
                          onClick={handleSave}
                          sx={{
                            backgroundColor: SPX_BLUE,
                            px: 4,
                            py: 1.5,
                            fontSize: "15px",
                            fontWeight: 600,
                            borderRadius: "8px",
                            textTransform: "none",
                            boxShadow: `0 4px 12px ${SPX_BLUE}50`,
                            "&:hover": { backgroundColor: SPX_DARK },
                          }}
                        >
                          Save Changes
                        </Button>
                        <Button
                          variant="outlined"
                          startIcon={<CancelIcon />}
                          onClick={() => {
                            setIsEditing(false);
                            setSaveError("");
                          }}
                          sx={{
                            borderColor: "#d32f2f",
                            color: "#d32f2f",
                            px: 4,
                            py: 1.5,
                            fontSize: "15px",
                            fontWeight: 600,
                            borderRadius: "8px",
                            textTransform: "none",
                            "&:hover": {
                              backgroundColor: "rgba(211,47,47,0.08)",
                              borderColor: "#c62828",
                            },
                          }}
                        >
                          Cancel
                        </Button>
                      </Box>
                    )}
                  </Box>
                )}
              </Box>
            </Fade>
          </Modal>

          {/* ══════════════════════════════════════════════════════
               PERSONNEL SUMMARY MODAL
          ══════════════════════════════════════════════════════ */}
          <Modal
            open={openSummaryModal}
            onClose={() => setOpenSummaryModal(false)}
            closeAfterTransition
            BackdropComponent={Backdrop}
            BackdropProps={{
              timeout: 500,
              sx: { backgroundColor: "rgba(0,0,0,0.7)" },
            }}
          >
            <Fade in={openSummaryModal}>
              <Box
                sx={{
                  position: "absolute",
                  top: "50%",
                  left: "50%",
                  transform: "translate(-50%,-50%)",
                  width: { xs: "98%", sm: "90%", md: "80%", lg: "70%" },
                  maxHeight: "90vh",
                  display: "flex",
                  flexDirection: "column",
                  bgcolor: "background.paper",
                  borderRadius: "16px",
                  boxShadow: "0 24px 48px rgba(0,0,0,0.25)",
                  overflow: "hidden",
                }}
              >
                <Box
                  sx={{
                    background: `linear-gradient(135deg, ${SPX_BLUE} 0%, ${SPX_DARK} 100%)`,
                    p: 3,
                    display: "flex",
                    justifyContent: "space-between",
                    alignItems: "center",
                    flexShrink: 0,
                  }}
                >
                  <Box sx={{ display: "flex", alignItems: "center", gap: 2 }}>
                    <Avatar
                      sx={{
                        bgcolor: "rgba(255,255,255,0.2)",
                        width: 48,
                        height: 48,
                      }}
                    >
                      <PeopleAltIcon sx={{ color: "white" }} />
                    </Avatar>
                    <Box>
                      <Typography
                        variant="h5"
                        sx={{ color: "white", fontWeight: 700 }}
                      >
                        Personnel Summary
                      </Typography>
                      <Typography
                        variant="body2"
                        sx={{ color: "rgba(255,255,255,0.8)" }}
                      >
                        SPX EXPRESS Riders Overview
                      </Typography>
                    </Box>
                  </Box>
                  <IconButton
                    onClick={() => setOpenSummaryModal(false)}
                    sx={{
                      color: "white",
                      "&:hover": { backgroundColor: "rgba(255,255,255,0.1)" },
                    }}
                  >
                    <CloseIcon />
                  </IconButton>
                </Box>

                <Box
                  sx={{
                    px: 3,
                    py: 1.5,
                    backgroundColor: "#f8f9fa",
                    borderBottom: "1px solid #e0e0e0",
                    flexShrink: 0,
                    display: "flex",
                    gap: 1.5,
                    flexWrap: "wrap",
                  }}
                >
                  <Chip
                    icon={
                      <TwoWheelerIcon sx={{ fontSize: "15px !important" }} />
                    }
                    label={`Total Riders: ${totalRiders}`}
                    size="small"
                    sx={{
                      fontWeight: 600,
                      backgroundColor: SPX_BLUE,
                      color: "white",
                      "& .MuiChip-icon": { color: "white" },
                    }}
                  />
                  <Chip
                    icon={
                      <CheckCircleOutlineIcon
                        sx={{ fontSize: "15px !important" }}
                      />
                    }
                    label={`Deployed: ${deployedRiders}`}
                    color="success"
                    size="small"
                    sx={{ fontWeight: 600 }}
                  />
                  <Chip
                    icon={
                      <WarningAmberIcon sx={{ fontSize: "15px !important" }} />
                    }
                    label={`In Process: ${floatingRiders.length}`}
                    color="warning"
                    size="small"
                    sx={{ fontWeight: 600 }}
                  />
                  <Chip
                    label={`Hubs Covered: ${hubsWithRiders}`}
                    color="primary"
                    size="small"
                    sx={{ fontWeight: 600 }}
                  />
                </Box>

                <Box sx={{ overflowY: "auto", flex: 1, px: 3, py: 2 }}>
                  <Box sx={{ mb: 3 }}>
                    <Box
                      sx={{
                        display: "flex",
                        alignItems: "center",
                        gap: 1.5,
                        mb: 1.5,
                      }}
                    >
                      <TwoWheelerIcon sx={{ color: SPX_BLUE, fontSize: 20 }} />
                      <Typography
                        variant="subtitle1"
                        sx={{ fontWeight: 700, color: SPX_BLUE }}
                      >
                        Riders by Hub
                      </Typography>
                      <Chip
                        label={`${hubsWithRiders} hubs`}
                        size="small"
                        sx={{
                          fontWeight: 700,
                          height: 22,
                          backgroundColor: SPX_BLUE,
                          color: "white",
                        }}
                      />
                    </Box>
                    <TableContainer
                      component={Paper}
                      elevation={0}
                      sx={{
                        border: "1px solid #e0e0e0",
                        borderRadius: "10px",
                        overflow: "hidden",
                      }}
                    >
                      <Table size="small">
                        <TableHead>
                          <TableRow sx={{ backgroundColor: "#fafafa" }}>
                            {[
                              "#",
                              "Hub",
                              "Region",
                              "Total Riders",
                              "Deployed",
                            ].map((h) => (
                              <TableCell
                                key={h}
                                sx={{
                                  fontWeight: 700,
                                  fontSize: "12px",
                                  borderBottom: "2px solid #e0e0e0",
                                }}
                              >
                                {h}
                              </TableCell>
                            ))}
                          </TableRow>
                        </TableHead>
                        <TableBody>
                          {buildHubSummary(hubAssignments)
                            .sort(
                              (a, b) =>
                                a.region.localeCompare(b.region) ||
                                a.hubName.localeCompare(b.hubName),
                            )
                            .map((h, idx) => {
                              const rCfg = REGION_COLORS[h.region] || {
                                bg: "#f5f5f5",
                                color: "#666",
                              };
                              return (
                                <TableRow
                                  key={h.hubId}
                                  sx={{
                                    "&:hover": { backgroundColor: "#fafafa" },
                                    "&:last-child td": { borderBottom: 0 },
                                  }}
                                >
                                  <TableCell
                                    sx={{ fontSize: "12px", color: "#666" }}
                                  >
                                    {idx + 1}
                                  </TableCell>
                                  <TableCell>
                                    <Typography
                                      variant="body2"
                                      sx={{ fontWeight: 600, fontSize: "12px" }}
                                    >
                                      {h.hubName}
                                    </Typography>
                                  </TableCell>
                                  <TableCell>
                                    <Chip
                                      label={h.region}
                                      size="small"
                                      variant="outlined"
                                      sx={{
                                        height: 18,
                                        fontSize: "10px",
                                        fontWeight: 600,
                                        borderColor: rCfg.color,
                                        color: rCfg.color,
                                      }}
                                    />
                                  </TableCell>
                                  <TableCell>
                                    <Chip
                                      label={h.riderCount}
                                      size="small"
                                      sx={{
                                        fontWeight: 700,
                                        height: 20,
                                        backgroundColor: SPX_BLUE,
                                        color: "white",
                                      }}
                                    />
                                  </TableCell>
                                  <TableCell>
                                    <Chip
                                      label={h.deployedCount}
                                      size="small"
                                      color={
                                        h.deployedCount > 0
                                          ? "success"
                                          : "default"
                                      }
                                      sx={{ fontWeight: 600, height: 20 }}
                                    />
                                  </TableCell>
                                </TableRow>
                              );
                            })}
                        </TableBody>
                      </Table>
                    </TableContainer>
                  </Box>

                  <Divider sx={{ my: 2 }} />

                  <Box>
                    <Box
                      sx={{
                        display: "flex",
                        alignItems: "center",
                        gap: 1.5,
                        mb: 1.5,
                      }}
                    >
                      <WarningAmberIcon
                        sx={{ color: "#e65100", fontSize: 20 }}
                      />
                      <Typography
                        variant="subtitle1"
                        sx={{ fontWeight: 700, color: "#e65100" }}
                      >
                        In Process Riders
                        <Typography
                          component="span"
                          variant="body2"
                          sx={{
                            ml: 1,
                            color: "#888",
                            fontWeight: 400,
                            fontSize: "12px",
                          }}
                        >
                          (no hub or hub not in list)
                        </Typography>
                      </Typography>
                      <Chip
                        label={floatingRiders.length}
                        color="warning"
                        size="small"
                        sx={{ fontWeight: 700, height: 22 }}
                      />
                    </Box>
                    {floatingRiders.length === 0 ? (
                      <Box
                        sx={{
                          textAlign: "center",
                          py: 3,
                          border: "1px dashed #c8e6c9",
                          borderRadius: "10px",
                          backgroundColor: "#f0f7f4",
                        }}
                      >
                        <CheckCircleOutlineIcon
                          sx={{ color: "#2e7d32", fontSize: 36, mb: 1 }}
                        />
                        <Typography
                          variant="body2"
                          sx={{ color: "#2e7d32", fontWeight: 600 }}
                        >
                          All riders are assigned to hubs!
                        </Typography>
                      </Box>
                    ) : (
                      <TableContainer
                        component={Paper}
                        elevation={0}
                        sx={{
                          border: "1px solid #ffe0b2",
                          borderRadius: "10px",
                          overflow: "hidden",
                        }}
                      >
                        <Table size="small">
                          <TableHead>
                            <TableRow sx={{ backgroundColor: "#fff8f0" }}>
                              {[
                                "#",
                                "Name",
                                "Position",
                                "Current Hub",
                                "Remarks",
                              ].map((h) => (
                                <TableCell
                                  key={h}
                                  sx={{
                                    fontWeight: 700,
                                    fontSize: "12px",
                                    color: "#e65100",
                                    borderBottom: "2px solid #ffcc80",
                                  }}
                                >
                                  {h}
                                </TableCell>
                              ))}
                            </TableRow>
                          </TableHead>
                          <TableBody>
                            {floatingRiders.map((emp, idx) => (
                              <TableRow
                                key={emp._id}
                                sx={{
                                  "&:hover": { backgroundColor: "#fff8f0" },
                                  "&:last-child td": { borderBottom: 0 },
                                }}
                              >
                                <TableCell
                                  sx={{ fontSize: "12px", color: "#666" }}
                                >
                                  {idx + 1}
                                </TableCell>
                                <TableCell>
                                  <Typography
                                    variant="body2"
                                    sx={{ fontWeight: 600, fontSize: "12px" }}
                                  >
                                    {emp.firstName} {emp.lastName}
                                  </Typography>
                                </TableCell>
                                <TableCell>
                                  <Typography
                                    variant="caption"
                                    sx={{ color: "#666" }}
                                  >
                                    {emp.position || "—"}
                                  </Typography>
                                </TableCell>
                                <TableCell>
                                  <Typography
                                    variant="caption"
                                    sx={{ color: "#888" }}
                                  >
                                    {emp.outlet || "—"}
                                  </Typography>
                                </TableCell>
                                <TableCell>
                                  <Chip
                                    icon={
                                      <WarningAmberIcon
                                        sx={{ fontSize: "13px !important" }}
                                      />
                                    }
                                    label="Not in Hub List"
                                    size="small"
                                    sx={{
                                      backgroundColor: "#fff3e0",
                                      color: "#e65100",
                                      fontWeight: 600,
                                      fontSize: "11px",
                                      border: "1px solid #ffcc80",
                                    }}
                                  />
                                </TableCell>
                              </TableRow>
                            ))}
                          </TableBody>
                        </Table>
                      </TableContainer>
                    )}
                  </Box>
                </Box>
              </Box>
            </Fade>
          </Modal>
        </Box>
      </Box>
    </>
  );
}
